"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _lodash = require("lodash");

var _pluralize = _interopRequireDefault(require("pluralize"));

var _DropDown = _interopRequireWildcard(require("../../DropDown"));

var _utils = require("../../SQONView/utils");

var _TextFilter = _interopRequireWildcard(require("../../TextFilter"));

var _download = _interopRequireDefault(require("../../utils/download"));

var _stringCleaner = _interopRequireDefault(require("../../utils/stringCleaner"));

var _helpers = _interopRequireDefault(require("./helpers"));

require("./Toolbar.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enhance = (0, _recompose.compose)((0, _recompose.withProps)(function (_ref) {
  var columns = _ref.columns;
  return {
    canChangeShowColumns: columns.filter(function (column) {
      return column.canChangeShow;
    })
  };
}), (0, _recompose.withPropsOnChange)(['onFilterChange'], function (_ref2) {
  var _ref2$onFilterChange = _ref2.onFilterChange,
      onFilterChange = _ref2$onFilterChange === void 0 ? function () {} : _ref2$onFilterChange;
  return {
    debouncedOnFilterChange: (0, _lodash.debounce)(onFilterChange, 300)
  };
}), (0, _recompose.withState)('filterVal', 'setFilterVal', ''), (0, _recompose.withPropsOnChange)(['sqon'], function (_ref3) {
  var sqon = _ref3.sqon,
      setFilterVal = _ref3.setFilterVal;
  if (!(0, _utils.currentFilterValue)(sqon)) setFilterVal('');
}));
/** Advanced Implementation details ****** (TODO: move to TS)
 * This component allows library integrators to pass custom exporters (functionality to be run on the data, e.g. get JSON)
 * They can provide their own function (default is saveTSV) through `exporter`, and leverage other props like
 * `exportTSVText` and `exportTSVFilename` in order to customise the resulting button; or they can display multiple
 * options in a dropdown, by passing an array of objects with details like so:
 *
 * exporter = [{
 *   label: '' || () => </>,
 *   fileName?: '',
 *   function?: () => {},
 *   columns?: [''] | [{ fieldName, displayName }],
 *   requiresRowSelection?: false,
 * }, ...]
 *
 * A label doesn't require an exporter function, and can be a React component (e.g. to display instructions, a divider, etc.)
 * furthermore, if label is 'saveTSV', Arranger will use its internal TSV exporter.
 * The function attribute accepts 'saveTSV' as well, in case you wish to use a custom label for it.
 * When a fileName is given without a custom function, Arranger will also produce a TSV file.
 * Columns passed here override the ones being displayed in the table.
 * the format for these is always an array, which could consist of one of the following types:
 * accessor strings, or objects with "fieldName" and "displayName" function/string.
 * If columns is undefined/null, the exporter will use all the columns shown in the table.
 * However, if columns is an empty array, the exporter will use all the columns declared in the column-state config.
 */

var TableToolbar = function TableToolbar(_ref4) {
  var _exporter$;

  var _ref4$allColumns = _ref4.allColumns,
      allColumns = _ref4$allColumns === void 0 ? [] : _ref4$allColumns,
      _ref4$allowTogglingCo = _ref4.allowTogglingColumns,
      allowTogglingColumns = _ref4$allowTogglingCo === void 0 ? true : _ref4$allowTogglingCo,
      _ref4$allowTSVExport = _ref4.allowTSVExport,
      allowTSVExport = _ref4$allowTSVExport === void 0 ? true : _ref4$allowTSVExport,
      canChangeShowColumns = _ref4.canChangeShowColumns,
      _ref4$columnDropdownT = _ref4.columnDropdownText,
      columnDropdownText = _ref4$columnDropdownT === void 0 ? 'Show columns' : _ref4$columnDropdownT,
      columns = _ref4.columns,
      _ref4$customActions = _ref4.customActions,
      customActions = _ref4$customActions === void 0 ? null : _ref4$customActions,
      _ref4$customHeaderCon = _ref4.customHeaderContent,
      customHeaderContent = _ref4$customHeaderCon === void 0 ? null : _ref4$customHeaderCon,
      debouncedOnFilterChange = _ref4.debouncedOnFilterChange,
      defaultColumns = _ref4.defaultColumns,
      downloadUrl = _ref4.downloadUrl,
      _ref4$enableDropDownC = _ref4.enableDropDownControls,
      enableDropDownControls = _ref4$enableDropDownC === void 0 ? false : _ref4$enableDropDownC,
      _ref4$enableSelectedT = _ref4.enableSelectedTableRowsExporterFilter,
      enableSelectedTableRowsExporterFilter = _ref4$enableSelectedT === void 0 ? false : _ref4$enableSelectedT,
      _ref4$selectedRowsFil = _ref4.selectedRowsFilterPropertyName,
      selectedRowsFilterPropertyName = _ref4$selectedRowsFil === void 0 ? 'file_autocomplete' : _ref4$selectedRowsFil,
      _ref4$exporter = _ref4.exporter,
      exporter = _ref4$exporter === void 0 ? null : _ref4$exporter,
      _ref4$exporterLabel = _ref4.exporterLabel,
      exporterLabel = _ref4$exporterLabel === void 0 ? 'Download' : _ref4$exporterLabel,
      _ref4$exportTSVFilena = _ref4.exportTSVFilename,
      exportTSVFilename = _ref4$exportTSVFilena === void 0 ? '' : _ref4$exportTSVFilena,
      _ref4$exportTSVText = _ref4.exportTSVText,
      exportTSVText = _ref4$exportTSVText === void 0 ? 'Export TSV' : _ref4$exportTSVText,
      _ref4$filterInputPlac = _ref4.filterInputPlaceholder,
      filterInputPlaceholder = _ref4$filterInputPlac === void 0 ? 'Filter' : _ref4$filterInputPlac,
      filterVal = _ref4.filterVal,
      InputComponent = _ref4.InputComponent,
      onColumnsChange = _ref4.onColumnsChange,
      onFilterChange = _ref4.onFilterChange,
      onMultipleColumnsChange = _ref4.onMultipleColumnsChange,
      _ref4$page = _ref4.page,
      page = _ref4$page === void 0 ? 0 : _ref4$page,
      _ref4$pageSize = _ref4.pageSize,
      pageSize = _ref4$pageSize === void 0 ? 0 : _ref4$pageSize,
      propsData = _ref4.propsData,
      _ref4$selectedTableRo = _ref4.selectedTableRows,
      selectedTableRows = _ref4$selectedTableRo === void 0 ? [] : _ref4$selectedTableRo,
      setFilterVal = _ref4.setFilterVal,
      _ref4$showFilterInput = _ref4.showFilterInput,
      showFilterInput = _ref4$showFilterInput === void 0 ? true : _ref4$showFilterInput,
      _ref4$sqon = _ref4.sqon,
      sqon = _ref4$sqon === void 0 ? {} : _ref4$sqon,
      style = _ref4.style,
      _ref4$total = _ref4.total,
      total = _ref4$total === void 0 ? (propsData === null || propsData === void 0 ? void 0 : propsData.total) || 0 : _ref4$total,
      _ref4$transformParams = _ref4.transformParams,
      transformParams = _ref4$transformParams === void 0 ? function (params) {
    return params;
  } : _ref4$transformParams,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? '' : _ref4$type;
  var isPlural = total > 1 && pageSize > 1 && (Math.ceil(total / pageSize) !== page || total % pageSize > 1);

  var _exporterProcessor = (0, _helpers["default"])(exporter, allowTSVExport, exportTSVText),
      singleExporter = _exporterProcessor.singleExporter,
      exporterArray = _exporterProcessor.exporterArray,
      multipleExporters = _exporterProcessor.multipleExporters;

  var hasSelectedRows = selectedTableRows.length > 0;
  var downloadSqon = enableSelectedTableRowsExporterFilter && hasSelectedRows ? {
    op: 'and',
    content: [{
      op: 'in',
      content: {
        field: selectedRowsFilterPropertyName,
        value: selectedTableRows
      }
    }]
  } : sqon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      display: 'flex',
      flex: 'none'
    }, style),
    className: "tableToolbar"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "currentlyDisplayed",
    style: {
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "numbers"
  }, "Showing ".concat((page * pageSize + 1).toLocaleString(), " - ").concat(Math.min((page + 1) * pageSize, total).toLocaleString())), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "ofTotal"
  }, "of ", total === null || total === void 0 ? void 0 : total.toLocaleString()), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "type"
  }, (0, _pluralize["default"])(type, isPlural ? 2 : 1))), customHeaderContent || null, showFilterInput && /*#__PURE__*/_react["default"].createElement("div", {
    className: "group"
  }, /*#__PURE__*/_react["default"].createElement(_TextFilter["default"], {
    InputComponent: InputComponent,
    value: filterVal,
    placeholder: filterInputPlaceholder,
    onChange: function onChange(_ref5) {
      var value = _ref5.value,
          generateNextSQON = _ref5.generateNextSQON;
      setFilterVal(value);
      debouncedOnFilterChange({
        value: value,
        generateNextSQON: generateNextSQON
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "group"
  }, allowTogglingColumns && (enableDropDownControls ? /*#__PURE__*/_react["default"].createElement(_DropDown.MultiSelectDropDown, {
    buttonAriaLabelClosed: "Open column selection menu",
    buttonAriaLabelOpen: "Close column selection menu",
    itemSelectionLegend: "Select columns to display",
    selectAllAriaLabel: "Select all columns",
    resetToDefaultAriaLabel: "Reset to default columns",
    itemToString: function itemToString(i) {
      return i.displayName || i.Header;
    },
    items: canChangeShowColumns,
    defaultColumns: defaultColumns,
    onChange: function onChange(item) {
      setFilterVal('');
      onFilterChange({
        value: '',
        generateNextSQON: (0, _TextFilter.generateNextSQON)('')
      });
      onColumnsChange(_objectSpread(_objectSpread({}, item), {}, {
        show: !item.show
      }));
    },
    onMultipleChange: function onMultipleChange(changes) {
      onMultipleColumnsChange(changes);
    }
  }, columnDropdownText) : /*#__PURE__*/_react["default"].createElement(_DropDown["default"], {
    "aria-label": "Select columns",
    itemToString: function itemToString(i) {
      return i.Header;
    },
    items: canChangeShowColumns,
    onChange: function onChange(item) {
      setFilterVal('');
      onFilterChange({
        value: '',
        generateNextSQON: (0, _TextFilter.generateNextSQON)('')
      });
      onColumnsChange(_objectSpread(_objectSpread({}, item), {}, {
        show: !item.show
      }));
    }
  }, columnDropdownText)), multipleExporters ?
  /*#__PURE__*/
  // check if we're given more than one custom exporter
  _react["default"].createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_DropDown["default"], {
    "aria-label": "Download options",
    itemToString: function itemToString(i) {
      return typeof i.exporterLabel === 'function' ? /*#__PURE__*/_react["default"].createElement(i.exporterLabel, null) : i.exporterLabel;
    },
    hasSelectedRows: hasSelectedRows,
    items: exporterArray,
    onChange: function onChange(_ref6) {
      var exporterColumns = _ref6.exporterColumns,
          exporterLabel = _ref6.exporterLabel,
          exporterFileName = _ref6.exporterFileName,
          exporterFunction = _ref6.exporterFunction,
          exporterRequiresRowSelection = _ref6.exporterRequiresRowSelection;
      return exporterRequiresRowSelection && !hasSelectedRows || (exporterFunction === null || exporterFunction === void 0 ? void 0 : exporterFunction(transformParams({
        files: [_objectSpread({
          allColumns: allColumns,
          columns: columns,
          fileName: exporterFileName ? "".concat(exporterFileName).concat(exporterFileName.toLowerCase().endsWith('.tsv') ? '' : '.tsv') : "".concat((0, _stringCleaner["default"])(exporterLabel.toLowerCase()), ".tsv"),
          fileType: 'tsv',
          index: type,
          sqon: downloadSqon
        }, exporterColumns && {
          exporterColumns: exporterColumns
        })],
        selectedTableRows: selectedTableRows,
        url: downloadUrl
      }), _download["default"]));
    },
    singleSelect: true
  }, exporterLabel)) : // else, use a custom function if any is given, or use the default saveTSV if the flag is on
  singleExporter && /*#__PURE__*/_react["default"].createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: (exporter === null || exporter === void 0 ? void 0 : (_exporter$ = exporter[0]) === null || _exporter$ === void 0 ? void 0 : _exporter$.requiresRowSelection) && !hasSelectedRows,
    className: (0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)("display:flex;min-height:16;white-space:nowrap;&:not(:disabled):hover{cursor:pointer;}")),
    onClick: function onClick() {
      var _exporter$2;

      (exporter === null || exporter === void 0 ? void 0 : (_exporter$2 = exporter[0]) === null || _exporter$2 === void 0 ? void 0 : _exporter$2.requiresRowSelection) && !hasSelectedRows || singleExporter(transformParams({
        files: [{
          columns: columns,
          fileName: exportTSVFilename || "".concat(type, "-table.tsv"),
          fileType: 'tsv',
          index: type,
          sqon: downloadSqon
        }],
        selectedTableRows: selectedTableRows,
        url: downloadUrl
      }), _download["default"]);
    }
  }, exportTSVText)), customActions));
};

var _default = enhance(TableToolbar);

exports["default"] = _default;